import config from "../../config/config";
import axios from "axios";
import { toast } from 'react-toastify';
import { formatDate } from "../../utils/formatDate";
import { getAuthToken } from "../../utils/token";
import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

const MaterialWastageReporModal = ({ show, handleClose, wastageId }) => {
  const [materialwastagereport, setMaterialwastagereport] = useState([])
  const [loading, setLoading] = useState(false);
    const [notes, setNotes] = useState("");

  const fetchMaterialwastagereport = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/manager/materialwastagereport/${wastageId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = response?.data;
      if (data.success === true) {
        setMaterialwastagereport(data?.wastage)

      } else {
        setMaterialwastagereport([]);
      }

    } catch (err) {
      console.error("Error fetching operators:", err.message);
      setMaterialwastagereport([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && wastageId) {
      fetchMaterialwastagereport();
    }
  }, [show, wastageId]);

  const handleInspect = async () => {
        const token = getAuthToken();
        if (!token) return;

        try {
            const payload = {
                material_information: {
                    quantity_wasted: materialwastagereport?.quantity,
                    unit: materialwastagereport?.unit,
                    wastage_reason: materialwastagereport?.reason,
                    notes:  materialwastagereport?.reason,
                },
                    notes: notes,
            };

            const response = await axios.post(
                `${config.API}/manager/updatematerialwastagereport/${wastageId}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            toast.success(response?.data?.message || "Material approved successfully");
            setNotes("");
            handleClose();
        } catch (error) {
            toast.error("Approval failed");
            console.error(error);
        }
    };


  return (
    <Modal show={show} onHide={handleClose} centered size="lg" className="font_family">
      <Modal.Body className="p-5">
        <h4 className="fw-bold mb-4">Material Wastage Report</h4>

        {/* Material Info */}
        <div className="p-3 border rounded bg-light mb-4">
          <h6 className="fw-semibold">Material Information</h6>
          <Row className="mt-2">
            <Col md={6}><strong>Material Name:</strong> {materialwastagereport?.material_master?.material_name}</Col>
            <Col md={6}><strong>Material ID:</strong> <span className="text-dark"> {materialwastagereport?.material_master?.material_code}</span></Col>
          </Row>
          <Row>
            <Col md={6}><strong>Qty Wasted:</strong> {materialwastagereport?.quantity} {materialwastagereport?.unit}</Col>
            <Col md={6}><strong>Date of Wastage:</strong> {formatDate(materialwastagereport?.created_at)}</Col>
          </Row>
        </div>

        {/* Supervisor Report */}
        <div className="p-3  bg-light mb-4">
          <h6 className="fw-semibold mb-3">Supervisor Report</h6>
          <Row className="align-items-center mb-3">
            <Col md={3}><strong>Quantity Wasted</strong></Col>
            <Col md={4}>
              <Form.Control
                type="number"
                value={materialwastagereport?.quantity || ""}
                readOnly
              />
            </Col>
            <Col md={4}>{materialwastagereport?.unit}</Col>
          </Row>

          <Row className="mb-3">
            <Col md={3}><strong>Wastage Reason</strong></Col>
           <Col md={4}>
              <Form.Control
                value={materialwastagereport?.reason || ""}
                readOnly
              />
            </Col>
          </Row>

          <Form.Group>
            <Row>
              <Col md={3}>
                <Form.Label><strong>Notes</strong></Form.Label></Col>
              <Col md={9}>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={materialwastagereport?.reason || ""}
                readOnly
                />
              </Col>
            </Row>
          </Form.Group>
        </div>

        <Form.Group className="mb-3">
          <Row>
            <Col md={3}>
              <Form.Label><strong>Notes</strong></Form.Label></Col>
            <Col md={9}><Form.Control
              as="textarea"
              rows={3}
               value={notes}
               onChange={(e) => setNotes(e.target.value)}
              placeholder="Lorem ipsum dolor sit amet consectetur. Et integer metus pretium cras. Duis urna curabitur integer commodo. Sit gravida ultrices cursus egestas. Nibh consectetur blandit dui enim sagittis. Iaculis."
            /></Col>
          </Row>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="border-0">
        <Button variant="secondary" onClick={handleClose}>Close</Button>
        <Button variant="dark" onClick={handleInspect} >Inspect</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MaterialWastageReporModal;
